import { cn } from '../cn';

type Props = {
  /**
   * Displays the number of notifications.
   */
  count?: number,
  /**
   * Sets a limit the count cannot exceed and applies a `+` symbol.
   */
  max?: number,
  className?: string,
  whiteBorder?: boolean,
}

const NotificationBadge = ({ count, max, whiteBorder, className }: Props): JSX.Element => {
  return (
    <div className={cn([
      'bg-error',
      'flex justify-center items-center rounded-[99px]',
      !count ? 'w-2 h-2' : 'text-text-contrast text-xs px-2 w-max h-5',
      whiteBorder && [
        'border-[3px] border-surface',
        !count ? 'w-3 h-3' : 'px-2 w-max h-5',
      ],
      className,
    ])}>
      {count && (<p className={cn([
        'leading-3 font-semibold inline',
      ])}>{max === undefined ? count : Math.min(max, count)}{(max && count) && count > max && (<span>+</span>)}</p>)}
    </div>
  );
};

export default NotificationBadge;
